import { parseStyle } from "./Style";
import { convertToOOXML, removeParagraph } from "./OOXML";
import { parseHTMLDOM } from "./HTML.DOM";


/**
 * 
 * @param {ChildNode} node 
 * @param {string} pr 
 * @returns 
 */
export function parseHTMLToOoxmlCursively(ctx, node, parentOOXML = null, pr = []) {
    if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent) {
            const style = parseStyle(node.parentNode);
            return [convertToOOXML({
                tag: "w:r",
                children: [
                    {tag: "w:rPr", ooxmlChildren: pr, children: style},
                    {
                        tag: "w:t", attrs: { "xml:space": "preserve" },
                        children: [{tag: "TEXT_NODE", children: node.textContent}]
                    }
                ]
            }, parentOOXML)];
        }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
        let result = [];
        const ooxmlChildren = [];
        if (node.nodeName === 'STYLE') return [];
        if (node.nodeName === 'P' || node.nodeName === 'DIV' || /^H\d/.test(node.nodeName)) {
            const style = node.nodeName === 'P' ? 'Normal' : node.nodeName.replace("H", "Heading ");
            const pPr = {tag: "w:pPr", children: [{ attrs: {"w:val": style },  tag: "w:pStyle" }],  ooxmlChildren: pr};
            const toNewParagraph = ooxmlChildren => convertToOOXML({ tag: "w:p", children: [pPr], ooxmlChildren}, parentOOXML);
            let children = [];
            Array.from(node.childNodes).forEach((cn) => {
                const processedOOXML = parseHTMLToOoxmlCursively(ctx, cn, parentOOXML, pr);
                processedOOXML.forEach(node => {
                    if (node._tag === 'w:p') {
                        if (children?.length) {
                            result.push(toNewParagraph(children));
                            children = [];
                        }
                        result.push(node);
                    } else if (node._tag === "w:tbl") {
                        if (children?.length) {
                            result.push(toNewParagraph(children));
                            children = [];
                        }
                        result.push(node);
                    } else {
                        children.push(node);
                    }
                });
            });

            if (children?.length) {
                result.push(toNewParagraph(children));
            }
            return result;
        }  else return parseHTMLDOM(ctx, parentOOXML, ooxmlChildren, node, pr, result);
    }
    return [];
}



export function htmlToOoxml(ctx, html, parentNode, ppr) {
    const shadowHost = document.createElement('div');
    const shadowRoot = shadowHost.attachShadow({ mode: 'closed' });
    shadowRoot.innerHTML = html.replaceAll(/&(?!amp;)/gi, "&amp;");
    const result = [];
    document.body.appendChild(shadowHost);
    if (ctx.removeParagraph) removeParagraph(document, shadowRoot);
        Array.from(shadowRoot.childNodes).map((cN) =>
            parseHTMLToOoxmlCursively(ctx, cN, parentNode, ppr)
        .forEach(d => result.push(d))
    );
    document.body.removeChild(shadowHost);
    return result;
}
